import CountWidget from "./CountWidget";
import ChartReporting from "./Chart";
import TabsTable from "./TabsTable";
import { useEffect } from "react";
import moment from "moment";
import axios from "../../axios-interceptor.js";
import { message } from "antd";
import { useTranslation } from 'react-i18next';

const BACKEND_API = process.env.REACT_APP_BACKEND_API
let tenantId = localStorage.getItem("tenantId")

const CreationsReport = (props) => {
    const { t } = useTranslation();
    const { reportingPeriod } = props;

    const getCreationsReport = (startDate, endDate) => {
        axios.get(`${BACKEND_API}/reports?startDate=${startDate}&endDate=${endDate}`)
        .then((response) => {
        })
        .catch(error => {
            message.error(t('Failed to get reports. Please try again.'))
        })
    }

    useEffect(() => {
        if(reportingPeriod) {
            let endDate = moment().format('DD-MM-YYYY');
            let startDate = moment();
            if(reportingPeriod.includes('m')) {
                let reqMonths = Number(reportingPeriod.split('m')[0])
                startDate = moment().subtract(reqMonths, 'months').format('DD-MM-YYYY')
            } else {
                startDate = moment().subtract(Number(props.reportingPeriod) - 1, 'days' ).format('DD-MM-YYYY');

            }
           
        }
    },[reportingPeriod])

    return (
        <div className="report-container">
        <div className="reporting-period">
            <div className="text-h5 text-weight-400 text-color-primary">{t('Time Period:')} </div>
            <div className="text-h5 text-weight-600 text-color-primary">{t('March 28, 2024 - April 28, 2024')}</div>
        </div>
        <div className="count-box-container">
            <CountWidget title={t('Number of unique creators')} count="4" percentage="300" />
            <CountWidget title={t('Total number of created versions')} count="10" percentage="900" />
        </div>

        <ChartReporting />
        <TabsTable />
    </div>
    )
}

export default CreationsReport